<div class="cSupportContainer">
    <div class="cManikcontainerwidth">
        <div class="mycityBgColor2">
            <div class="cHeaderLeft">Instaciti regional partners/distributors</div>
            <div class="cHeaderRight">
                <a href="javascript:void()" (click)="closeDialog();">
                    <span class="material-icons">close</span>
                </a>
            </div>
        </div>
        <div class="cInstaCitiSupport2">
            <div class="form-group">
                <input type="text" placeholder="Select Country" (keyup)="filterCountries($event);"
                class="form-control" [(ngModel)]="SelectedCountry"
               [matAutocomplete]="keywords" />
             <mat-autocomplete #keywords="matAutocomplete" (optionSelected)="PopulateSupportList($event.option.value)">
               <mat-option *ngFor="let item of filteredCountries" [value]="item.CountryName">
                 {{item.CountryName}}
               </mat-option>
             </mat-autocomplete>
            </div>
        </div>
    </div>
    <div class="row" *ngFor="let item of SupportList">
        <div class="col-lg-4">
            <div class="cManikCustomWidth">
                <div class="cInstaCitiSupport1">
                    <img [src]="item.SupportLogoURL" />
                </div>
            </div>
        </div>
        <div class="col-lg-8">
            <table class="cSupportData">
                <tr>
                    <th><span>Email </span> </th>
                    <th>
                        <div [innerHTML]="item.SupportEmail"></div>
                    </th>
                </tr>
                <tr>
                    <th><span>Phone </span> </th>
                    <th>
                        <div [innerHTML]="item.SupportPhoneNumber"></div>
                    </th>
                </tr>
                <tr>
                    <th><span>Contact person </span> </th>
                    <th>
                        <div [innerHTML]="item.SupportContactPerson"></div>
                    </th>
                </tr>
                <tr>
                    <th><span>Address </span> </th>
                    <th>
                        <div [innerHTML]="item.SupportAddrress"></div>
                    </th>
                </tr>
                <tr>
                    <th><span>Additional Info </span> </th>
                    <th>
                        <div [innerHTML]="item.SupportAddlInfo"></div>
                    </th>
                </tr>
            </table>
        </div>
    </div>
</div>